import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { MessageInfo } from './models/monitoring-messages.model';
import messageService from '../services/messages';

interface GetSmsAllParams {
  phoneNumber: string;
  page: number;
  pageSize: number;
}

interface PassengerDetailsResponse {
  items: Passenger[];
}

interface Passenger {
  passengerUUID: string;
  firstName: string;
  lastName: string;
}

export const getSmsAll1 = createAsyncThunk(
  'message/getSmsAll',
  async (
    { phoneNumber, page = 1, pageSize = 10 }: GetSmsAllParams,
    { rejectWithValue },
  ) => {
    try {
      return await new Promise((resolve, reject) => {
        messageService.getSmsAll(phoneNumber, page, pageSize).subscribe({
          next: resolve,
          error: reject,
        });
      });
    } catch (error) {
      return rejectWithValue('An unknown error occurred');
    }
  },
);
export const getSmsAll = createAsyncThunk(
  'message/getSmsAll',
  async (
    { phoneNumber, page = 1, pageSize = 10 }: GetSmsAllParams,
    { rejectWithValue },
  ) => {
    try {
      // Fetch the SMS messages as before
      const smsResponse: any = await new Promise((resolve, reject) => {
        messageService.getSmsAll(phoneNumber, page, pageSize).subscribe({
          next: (response) => resolve(response),
          error: reject,
        });
      });

      // Fetch passenger details to append the name to the response
      const passengerDetails: PassengerDetailsResponse = await new Promise(
        (resolve, reject) => {
          messageService
            .getPassengerDetails(1, 1, 'APIClient1352', '1913284465')
            .subscribe({
              next: (response) => resolve(response as PassengerDetailsResponse),
              error: reject,
            });
        },
      );

      if (passengerDetails.items && passengerDetails.items.length > 0) {
        const passenger = passengerDetails.items[0];
        const name = `${passenger.firstName} ${passenger.lastName}`;

        smsResponse.name = name;
      }
      return smsResponse;
    } catch (error) {
      return rejectWithValue('An unknown error occurred');
    }
  },
);

interface MessageState {
  messages: MessageInfo[];
  name: string;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
}

const initialState: MessageState = {
  messages: [],
  name: '',
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
  loading: false,
  error: null,
};

export const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSmsAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSmsAll.fulfilled, (state, action: PayloadAction<any>) => {
        const { messages, name, totalItems, totalPages, currentPage } =
          action.payload ?? {};
        state.messages = messages ?? [];
        state.name = name;
        state.totalItems = totalItems ?? 0;
        state.totalPages = totalPages ?? 0;
        state.currentPage = currentPage ?? 1;
        state.loading = false;
      })
      .addCase(getSmsAll.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch messages';
        state.loading = false;
      });
  },
});

export default messageSlice.reducer;
